/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerFindOneQueryResponse, TemplateQuestionsControllerFindOnePathParams, TemplateQuestionsControllerFindOneQueryParams, TemplateQuestionsControllerFindOne400, TemplateQuestionsControllerFindOne401, TemplateQuestionsControllerFindOne403, TemplateQuestionsControllerFindOne404 } from "../../models/checklistsController/TemplateQuestionsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateQuestionsControllerFindOne } from "../../clients/checklistsService/templateQuestionsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateQuestionsControllerFindOneQueryKey = (id: TemplateQuestionsControllerFindOnePathParams["id"], params: TemplateQuestionsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-template-questions/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TemplateQuestionsControllerFindOneQueryKey = ReturnType<typeof templateQuestionsControllerFindOneQueryKey>;
export function templateQuestionsControllerFindOneQueryOptions(id: TemplateQuestionsControllerFindOnePathParams["id"], params?: TemplateQuestionsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateQuestionsControllerFindOneQueryKey(id, params);
  return queryOptions<TemplateQuestionsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionsControllerFindOne400 | TemplateQuestionsControllerFindOne401 | TemplateQuestionsControllerFindOne403 | TemplateQuestionsControllerFindOne404>, TemplateQuestionsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateQuestionsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific checklist template question by ID
 * {@link /api/v1/checklist-template-questions/:id}
 */
export function useTemplateQuestionsControllerFindOne<TData = TemplateQuestionsControllerFindOneQueryResponse, TQueryData = TemplateQuestionsControllerFindOneQueryResponse, TQueryKey extends QueryKey = TemplateQuestionsControllerFindOneQueryKey>(id: TemplateQuestionsControllerFindOnePathParams["id"], params?: TemplateQuestionsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateQuestionsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionsControllerFindOne400 | TemplateQuestionsControllerFindOne401 | TemplateQuestionsControllerFindOne403 | TemplateQuestionsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateQuestionsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...templateQuestionsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateQuestionsControllerFindOne400 | TemplateQuestionsControllerFindOne401 | TemplateQuestionsControllerFindOne403 | TemplateQuestionsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}